import TabNavigation from './TabNavigation';
import type { TabNavigationProps } from './TabNavigation';

export type { TabNavigationProps };
export default TabNavigation;
